(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hr-hms-interest"]) return;
  try {
    
  (() => {
    let attempts = 0;

    const polishForms = () => {
      let pending = false;
      document.querySelectorAll('.hr-hms-interest').forEach((section) => {
        const shadowRoot = section.querySelector('shopify-forms-embed')?.shadowRoot;
        if (!shadowRoot) {
          pending = true;
          return;
        }
        if (shadowRoot.getElementById('hr-hms-interest-form-style')) return;

        const style = document.createElement('style');
        style.id = 'hr-hms-interest-form-style';
        style.textContent = `
          form[class*="formFieldset"] {
            box-sizing: border-box !important;
            width: calc(100% - 4px) !important;
          }
          [class*="formDisclaimer"] {
            margin-top: 18px !important;
            padding-top: 16px !important;
            border-top: 1px solid rgba(230, 189, 105, .2);
            color: rgba(255, 248, 233, .82) !important;
            font-size: 14px !important;
            line-height: 1.55 !important;
          }
          [class*="formDisclaimer"] p,
          [class*="formDisclaimer"] a {
            font-size: inherit !important;
            line-height: inherit !important;
          }
          [class*="formDisclaimer"] a {
            color: #f1d78a !important;
            text-underline-offset: 3px;
          }
        `;
        shadowRoot.appendChild(style);
      });

      if (pending && ++attempts < 80) window.setTimeout(polishForms, 250);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', polishForms, { once: true });
    } else {
      polishForms();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
